import { render, staticRenderFns } from "./RequisitionDetail.vue?vue&type=template&id=dec8ad2c&scoped=true"
import script from "./RequisitionDetail.vue?vue&type=script&lang=js"
export * from "./RequisitionDetail.vue?vue&type=script&lang=js"
import style0 from "./RequisitionDetail.vue?vue&type=style&index=0&id=dec8ad2c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dec8ad2c",
  null
  
)

export default component.exports